import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorAlertProps {
    readonly message: string;
    readonly onDismiss?: () => void;
    readonly className?: string;
    readonly showIcon?: boolean;
}

export default function ErrorAlert({ 
    message, 
    onDismiss, 
    className = "", 
    showIcon = true 
}: ErrorAlertProps) {
    return (
        <div className={`mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg flex items-center gap-2 mx-auto ${className}`}>
            {showIcon && <AlertCircle size={18} />}
            <span className="text-sm flex-grow">{message}</span>
            {onDismiss && (
                <button 
                    onClick={onDismiss}
                    className="ml-auto text-red-700 hover:text-red-900 text-lg leading-none"
                    aria-label="Dismiss error"
                >
                    ×
                </button>
            )}
        </div>
    );
} 